import { createSlice } from "@reduxjs/toolkit"

const ProjectSlice = createSlice({
  name: "Global",
  initialState: {
    selectetProject: "",
  },

  reducers: {
    setSelectetProject: (state, action) => ({
      ...state,
      selectetProject: action.payload,
    }),
  },
})

export const { setSelectetProject } = ProjectSlice.actions

export default ProjectSlice.reducer
